import script from "./single-select.vue?vue&type=script&setup=true&lang=ts"
export * from "./single-select.vue?vue&type=script&setup=true&lang=ts"

import "./single-select.vue?vue&type=style&index=0&id=17fe36f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17fe36f8"]])

export default __exports__